<div class="esri-component esri-widget--button esri-widget marque-zoom" role="button" (click)="onClick()">
  <span class="dragZoom esri-icon esri-icon-zoom-in-magnifying-glass" title="Marque zoom"></span>
  <span class="esri-icon-font-fallback-text">Marque zoom</span>
</div>
